// extracted by mini-css-extract-plugin
export default {"link":"link_link__Zkmqt","link_not_clickable":"link_link_not_clickable__+axSm"};